import React, { useEffect, useRef,useState } from 'react';
import { Card, Popconfirm, message, Space, Input, Flex, Tag, Select} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../config';

const tagInputStyle = {
  width: 64,
  height: 22,
  marginInlineEnd: 8,
  verticalAlign: 'top',
};

const LabelComponent = ({ user, targetUserId }) => {
  const [tagsDatata, setTagsDatata] = useState([]); // 卡片主获得的标签及标签点赞数
  const [selectedTags, setSelectedTags] = useState([]); // 用户选择的标签
  const [tagsData, setTagsData] = useState([]); // 所有标签
  const [rightClickedTag, setRightClickedTag] = useState(null); // 右击的标签
  const [newTag, setNewTag] = useState(''); // 新标签输入
  const [inputVisible, setInputVisible] = useState(false);
  const inputRef = useRef(null);

  const handleChange = value => {
    console.log(`selected ${value}`);
    update_lablelike(value);
  };
  const handleChangeta = (tag) => {
    update_lablelike(tag);
    console.log('更新标签成功 ');
  };

  const handleTagRightClick = (tag, event) => {
    console.log('右击标签:', tag);
    setRightClickedTag(tag);
  };

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  const showInput = () => {
    setInputVisible(true);
  };
  const update_lablelike = async (tag) => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/update_lablelike`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tag: tag,
          u2: targetUserId,
          u1: user.userId
        })
      });
      const data = await response.json();
      if (data) {
        console.log("更新标签点赞成功");
        searchlableta();
        searchlableme();
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };
  const inserttag = async (tag) => {
    setInputVisible(false);
    try {
      const response = await fetch(`${API_BASE_URL}/database/insert_lable`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tag: tag,
          u1: user.userId
        })
      });
      const data = await response.json();
      if (data) {
        console.log("插入标签成功");
        searchlableall();
        update_lablelike(tag);
      } else {
        update_lablelike(tag);
      }
    } catch (error) {
      console.error('插入标签失败:', error);
    }
  };

  const handleDeleteTag = async () => {
    if (!rightClickedTag) return;
    try {
      const response = await fetch(`${API_BASE_URL}/database/delete_tag`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tag: rightClickedTag,
          u1: user.userId
        })
      });
      const result = await response.json();
      if (result) {
        message.success('删除成功');
        // 重新获取标签信息
        searchlableta();
        searchlableall();
        searchlableme();
      } else {
        message.error('删除失败,只能删除自己添加的标签');
      }
    } catch (error) {
      console.error('删除标签失败:', error);
    }
    setRightClickedTag(null);
  };

  const searchlableall = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_lableall`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data) {
        console.log("标签总数据：", data);
        setTagsData(data);
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  const searchlableta = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_lableta`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: targetUserId
        })
      });
      const data = await response.json();
      if (data) {
        console.log("他获得的点赞标签数据：", data);
        setTagsDatata(data);
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  const searchlableme = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_lableme`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          u1: user.userId,
          u2: targetUserId
        })
      });
      const data = await response.json();
      if (data) {
        console.log("我给他点赞的标签数据：", data);
        setSelectedTags(data);
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };

  useEffect(() => {
    if (targetUserId && user) {
      searchlableta();
      searchlableall();
      searchlableme();
    }
  }, [targetUserId, user]);

  return (
    <Card style={{ marginBottom: 16 }}>
      <Flex gap={4} wrap>
        <span style={{ fontSize: '16px' }}>获得标签 :  </span>
        {tagsDatata.map(tag => (
          <Popconfirm
            key={tag.value}
            title="确定要删除这个标签吗？"
            open={rightClickedTag === tag.value}
            onConfirm={handleDeleteTag}
            onCancel={() => setRightClickedTag(null)}
            okText="确定"
            cancelText="取消"
          >
            <Tag.CheckableTag
              checked={selectedTags.includes(tag.value)}
              onChange={checked => handleChangeta(tag.value, checked)}
              onContextMenu={(e) => {
                e.preventDefault();
                handleTagRightClick(tag.value, e);
              }}
              style={{ fontSize: '16px' }}
            >
              {tag.value} +{tag.count}
            </Tag.CheckableTag>
          </Popconfirm>
        ))}
      </Flex>
      <br></br>
      <Flex gap={4} wrap>
        <span style={{ fontSize: '16px' }}>可选标签 :  </span>
        <Select
          style={{ width: 120 }}
          onChange={handleChange}
          options={tagsData}
        />
        {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={tagInputStyle}
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onBlur={() => {
              if (newTag.trim()) {
                inserttag(newTag.trim());
                setNewTag('');
              }
            }}
          onPressEnter={() => {
              if (newTag.trim()) {
                inserttag(newTag.trim());
                setNewTag('');
              }
            }}
        />
      ) : (
        <Tag  icon={<PlusOutlined />} onClick={showInput}>
          New Tag
        </Tag>
      )}
      </Flex>
    </Card>
  );
};

export default LabelComponent;